import styled, { css } from 'styled-components';

import { setSvgColor } from 'styles/mixins';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme }) => css`
    .text-divider {
      width: 24px;
      height: 24px;
      text-align: center;
      color: ${theme.colors.lightGrey.main};
    }
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme }) => css`
    gap: ${theme.padding.extraSmall};
    ${setSvgColor(theme.colors.lightGrey.main)}

    p {
      color: ${theme.colors.lightGrey.main};
    }
  `}
`;
